const config = {

  Menu: "WebContent/GetMenus",
  Campaign: "Campaign",
  Project: "Project",
  DonationProject: "Donation/project",
  DonationCampaign: "Donation/campaign",
  DonationPlatform: "donations/platform",
  DonationPlatformMonthly: "donations/platform/monthly",
  SuccessPayment: "Donation/by-session/",
  MyDonations: "MyDonations",
  Language: "Language",
  // About Us Page
  AboutUsStory: "AboutUs/story",
  AboutUsVision: "AboutUs/vision",
  AboutUsMission: "AboutUs/mission",
  AboutUsValues: "AboutUs/values",
  AboutUsGoals: "AboutUs/goals",
  AboutUsDocuments: "AboutUs/documents",

  // Home Page
  HomePageSliders: "HomePage/sliders",
  HomePageDonationBanner: "HomePage/donation-banner",
  Partner: "Partner",
  TeamMember: "TeamMember",

  // Achievements
  Achievements: "achievement",
  SuccessStory: "SuccessStory",
  Category:
    "Category",
  ContactUs: "ContactUs",

  // Settings
  Configuration: "Configuration/dictionary-view",

  // Donor Auth
  DonorAuthRegister: "donor-auth/register",
  DonorAuthVerifyEmail: "donor-auth/verify-email",
  DonorAuthResendVerification: "donor-auth/resend-verification",
  DonorAuthLogin: "donor-auth/login",
  DonorAuthForgotPassword: "donor-auth/forgot-password",
  DonorAuthVerifyForgotPassword: "donor-auth/verify-forgot-password",
  DonorAuthResetPassword: "donor-auth/reset-password",

  // Donor Profile
  DonorProfile: "donor-profile",
  DonorProfileChangePassword: "donor-profile/change-password",
  DonorProfileLogout: "donor-profile/logout",

  // LOCAL STORAGE KEYS
  lang: "_lang",
  localLang: "lang",
  TOKEN_KEY: "_naqsh_donor_token",
  REFRESH_TOKEN_KEY: "_naqsh_donor_refresh_token",
  PENDING_VERIFICATION_EMAIL_KEY: "_naqsh_pending_verification_email",
  RESET_PASSWORD_EMAIL_KEY: "_naqsh_reset_password_email",
  RESET_PASSWORD_CODE_KEY: "_naqsh_reset_password_code",
  // COOKIES_KEYS

  // APP Name
  appName: "Naqsh Platform",
  APIKEY: "",

  // Dev
  // API_URL: "https://naqsh1.quivyo.com/api/v1",
  // Staging
  API_URL: "https://naqsh-staging.quivyo.com/api/v1",
  // Production
  // API_URL: "https://api-dev.naqshfoundation.ngo/api/v1",
  baseUrl: "",
  filesBaseUrl: "",
};

const environment = {
  ...config,
};

export default environment;
